export const adminPermissions = [
  'orders',
  'products-menu',
  'organization-menu',
  'tables',
  'user-config',
  'profile-config',
  'doubts-config',
  'assessment-config',
  'call-waiter-config',
  'logo-stablishment-config',
]
